(ns pfo.chat.tool.collection-component
  (:require
   [reagent.core :as r :refer [atom] :refer-macros [with-let]]
   [promesa.core :as p]
   [clojure.data :refer [diff]]
   [clojure.string :as str]
   [lentes.core :as l]
   [pfo.api :as api :refer [process-error]]
   [pfo.admin.model :refer [group-admin-permitted-users]]
   [pfo.admin.component :as admin :refer [contact-user-add]]
   [pfo.auth.model :as auth-model]
   [pfo.controller :as controller :refer [subscribe]]
   [pfo.collection.model :as collection-model]
   [pfo.collection.component :as collection]
   [pfo.coltype.model :as coltype-model]
   [pfo.coltype.components.details :as coltype]
   [pfo.coltype.component :as coltype-component :refer [collection-type-form coltype-template-data-sources]]
   [pfo.chat.common-component :refer [add-sidebar-panel]]
   [pfo.util :as util]
   [pfo.widget.help :refer [help-popover]]
   [pfo.form :as form]
   [pfo.chat.tool.collection :as tool-collection]
   [pfo.state :as state]
   [pfo.common.component :as common]))

(declare retrieve-fields)

(def catom clojure.core/atom)

(defn collection-edit-sidebar-panel [options collection-type-form-component title active]
  (with-let []
    [:div.cs-expansion-panel__inside [:span {:on-click (util/handler
                                                        (fn []
                                                          (some-> (:on-toggle-open options) (apply []))))} title]
     (when active
       [:div
        [:div
         [collection-type-form-component]]])]))

(defn collection-edit-sidebar-panels [options get-collection-type-form-fn form-def *active-form]
  [:div (doall (map
                (fn [{:keys [index label]}]
                  ^{:key index}
                  [collection-edit-sidebar-panel (merge options
                                                        {:on-toggle-open (fn [] (if (= @*active-form index)
                                                                                  (reset! *active-form nil)
                                                                                  (reset! *active-form index)))})
                   (partial get-collection-type-form-fn index)
                   label (= @*active-form index)]) (filter identity (:forms form-def))))])

(defn segment-header [_ field-status]
  [:div.o-media.c-segment-header-extra-content])

(defn field-controls [{:keys [approve-cb
                              reject-cb
                              edit-cb]} _]
  [:div.c-field-controls
   [:input.svg-icon--md {:type :image
                         :src "/static/img/icons/edit.svg"
                         :on-click (util/handler edit-cb)}]])

(defn help-tooltip [help-component]
  (with-let [*show-tooltip (atom false)]
    [:div.c-info-tooltip
     [:img.c-info-icon {:src "/static/img/icons/info.svg"
                        :on-click (util/handler #(swap! *show-tooltip not))}]
     (when @*show-tooltip
       [:div.c-tooltip-popup
        [:div.c-tooltip-text
         help-component]])]))

(defn user-vertical-list [users]
  (let [users (or users [])]
    [:div.c-user-vertical-list
     (doall
      (map (fn [u]
             ^{:key (:id u)} [:div.c-user-vertical-list__item (auth-model/get-full-name u)])
           users))]))

(defn permissions [options family-id *parent-id *permitted-user-ids]
  (with-let [*family-permitted-users (atom nil)
             *parent-permitted-users (atom nil)
             set-user-ids (fn [family-permitted-ids permitted-ids]
                            (reset! *permitted-user-ids (into #{} (filterv #(contains? family-permitted-ids %) permitted-ids))))
             load-permitted-users (fn [collection-id users-atom]
                                    (controller/dispatch :permitted-users :load {:collection-ids collection-id
                                                                                 :regular-only true
                                                                                 :on-success (fn [response]
                                                                                               (reset! users-atom response))}))
             *parent (subscribe :collection-details)
             _ (controller/dispatch :collection-details :clear)
             _ (controller/dispatch :collection-details :load {:collection-id @*parent-id})
             _ (load-permitted-users family-id *family-permitted-users)
             _ (load-permitted-users @*parent-id *parent-permitted-users)
             _ (add-watch *parent-id :parent-changed (fn [_ _ old-parent updated-parent]
                                                       (when-not (= old-parent updated-parent)
                                                         (do
                                                           (controller/dispatch :collection-details :load {:collection-id updated-parent})
                                                           (load-permitted-users updated-parent *parent-permitted-users)))))]
    (when @*parent
      [:div
       [:h3 "Set Permissions"]
       (when (:batch-create options)
         [:div.u-padding-bottom--xs "This will overide any permissions set on the individual collections"])
       [:div.u-padding-bottom--xs.u-font-weight--bolder.u-font-size--smaller  "Select all users that should have access to this collection"]
       [:div.u-padding-bottom--xs
        (when-not (:hide-populate-from-parent options)
          [:<>
           [:button.c-button--small {:on-click (util/handler
                                                (fn []
                                                  (set-user-ids (into #{} (mapv #(:id %) @*family-permitted-users)) (mapv #(:id %) @*parent-permitted-users))))} "Populate from Parent"]
           [help-tooltip
            [:div
             [:h4 (str (:name @*parent) " (parent) gives access to the following users:")]
             [user-vertical-list @*parent-permitted-users]]]])
        [:div
         [:label.u-padding-top--xs
          [:input {:type "checkbox"
                   :checked (= (count @*family-permitted-users) (count @*permitted-user-ids))
                   :ref (fn [el] (when el (set! (.-indeterminate el) (and (> (count @*permitted-user-ids) 0)
                                                                          (< (count @*permitted-user-ids) (count @*family-permitted-users))))))
                   :on-change (fn [ev]
                                (if (= (count @*family-permitted-users) (count @*permitted-user-ids))
                                  (reset! *permitted-user-ids #{})
                                  (reset! *permitted-user-ids (set (map :id @*family-permitted-users)))))}] [:span.u-font-weight--bolder "Select All"]]]
        [:ul
         (doall
          (for [{user-id :id
                 :as user} @*family-permitted-users]
            [:li {:key (:id user)}
             [:label
              [:input (form/set-checked
                       (contains? @*permitted-user-ids user-id)
                       {:on-click (fn [ev]
                                    (let [selected (-> ev .-target .-checked)]
                                      (if selected
                                        (swap! *permitted-user-ids conj user-id)
                                        (swap! *permitted-user-ids disj user-id))))})]
              (auth-model/get-full-name user)]]))]]])))

(defn create-collection [{:keys [*sidebar-panels
                                 *disabled
                                 *selected-family-id
                                 register-confirm-action-fn
                                 tool-update-success-cb
                                 family-id]
                          :as options}
                         system-message-obj
                         {{:as args} :arguments
                          :as tool-call}]
  (with-let [*parent-id (atom (:parent_id args))
             *parent-name (atom nil)
             *name (atom (:name args))
             *collection-type-id (atom (:collection_type_id args))
             *coltype (atom nil)
             *create-review (atom (:create_review args))
             *permitted-user-ids (atom #{})
             *expanded (atom (not (:batch-create options)))
             _ (register-confirm-action-fn (fn []
                                             (let [args (merge args
                                                               {:parent_id @*parent-id
                                                                :name @*name
                                                                :collection_type_id (util/somestr-to-int @*collection-type-id)
                                                                :create_review @*create-review})]
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args args
                                                 :system-args {:permitted_user_ids @*permitted-user-ids}
                                                 :success-cb tool-update-success-cb}))))
             _ (when (:*batch-permitted-user-ids options)
                 (add-watch (:*batch-permitted-user-ids options) (str "batch-permitted-user-ids-changed-" (:id tool-call))
                            (fn [_ _ old-permitted-user-ids new-permitted-user-ids]
                              (reset! *permitted-user-ids new-permitted-user-ids))))
             _ (when (:*parent-id-atoms options)
                 (add-watch *parent-id (str "parent-id-" (:id tool-call))
                            (fn [_ _ old-parent-id new-parent-id]
                              (reset! (get (:*parent-id-atoms options) (:id tool-call)) new-parent-id))))]

    [:div
     (when-not (:batch-create options) [:h2.u-margin-top--xs "Create collection"])
     [:div.cs-collection-create {:class (when (:batch-create options) "Batch")}
      (when (:batch-create options)
        [:div.cs-expander {:class (if @*expanded "expanded" "collapsed")
                           :on-click (util/handler #(swap! *expanded not))}
         [:img {:src "/static/img/icons/arrow-expand.svg" :alt "expand-collapse"}]])
      [:div.cs-collection-content
       (when (:batch-create options)
         [:div.o-space-between.u-padding-bottom
          [:div.u-display--flex.u-align-items--center
           [:div
            [:div.u-font-weight--bolder @*name]
            [:div.u-color--secondary.u-font-size--smaller (get-in @*coltype [:asset_type :name]) ": " (:name @*coltype)]
            [:div.u-color--secondary.u-font-size--smaller "Parent: " @*parent-name]]]
          [:div.cs-permissions {:class (if (empty? @*permitted-user-ids) "NotSet" "Set")} (if (empty? @*permitted-user-ids) "User permissions not set" "User permissions set")]])
       [:div  (when-not @*expanded {:class "u-display--none"})
        [collection/collection-details-edit
         {:forms-change-status-atom (catom {})
          :form-class "c-form--edit"
          :active-form :details
          :disable-save true
          :hide-form-header true
          :allow-parent-choice true
          :hide-active true
          :value-atoms {:name *name
                        :collection-type-id *collection-type-id
                        :coltype *coltype
                        :create-review *create-review
                        :parent-name *parent-name}}
         nil
         *parent-id
         family-id]
        [:div.c-divider.u-padding-bottom--xs]
        [permissions (assoc options
                            :hide-populate-from-parent (= @*parent-id family-id)) family-id *parent-id *permitted-user-ids]]]]]))

(defn update-collection [{:keys [*sidebar-panels
                                 *disabled
                                 register-confirm-action-fn
                                 tool-update-success-cb
                                 *sidebar-open]
                          :as options}
                         system-message-obj
                         {{collection-name :collection_name
                           parent-collection-id :parent_collection_id
                           collection-id :collection_id
                           :as args} :arguments
                          :as tool-call}]
  (with-let [parent-collection (atom nil)
             family-id (atom nil)
             *data-sources (atom nil)
             collection-type (atom nil)
             *collection (atom nil)
             _ (controller/dispatch :collection-type-form-def :clear)
             structured-data2 (atom (:meta tool-call))
             suggested-field-refs (set (keys @structured-data2))
             suggested-field-key? (fn [suggested-refs ref-name]
                                    (some (fn [suggested-ref]
                                            (let [sname (name suggested-ref)]
                                              (or (= ref-name sname)
                                                  (some #(= ref-name (str sname %))
                                                        ["_objects" "_attrs" "_percentage" "_options"
                                                         "_ownership" "_object" "_asset_collection" "_export_key"]))))
                                          suggested-refs))
             form-def (atom nil)
             *all-flattened-fields (atom nil)
             *permitted-groups (atom nil)
             *user-edited-refs (atom #{})
             _ (add-watch structured-data2 :doc-fields-watch
                          (fn [_ _ old-data new-data]
                            (let [changed-doc-fields (filter (fn [field]
                                                               (not=
                                                                (get old-data (keyword (:ref field)))
                                                                (new-data (keyword (:ref field)))))
                                                             (tool-collection/get-all-doc-fields @*all-flattened-fields @structured-data2))]
                              (when (seq changed-doc-fields)
                                (tool-collection/populate-document-objects! changed-doc-fields @structured-data2
                                                                            (fn [document-field-objects-map]
                                                                              (swap! structured-data2 merge document-field-objects-map)
                                                                              (swap! *collection assoc :data document-field-objects-map)))))))
             _ (->>
                (p/all [(collection-model/collection-full-details (or collection-id parent-collection-id) false)
                        (collection-model/permitted-groups (or collection-id parent-collection-id))])
                (p/map
                 (fn [[parent-col permitted-groups]]
                   (reset! parent-collection parent-col)
                   (swap! structured-data2 #(merge (:data parent-col) %))
                   (add-watch structured-data2
                              :user-edit-watch
                              (fn [_ _ oldv newv]
                                (let [[_ changed _] (diff oldv newv)]
                                  (swap! *user-edited-refs into (keys changed)))))
                   (reset! *permitted-groups permitted-groups)
                   (reset! family-id (:group_id parent-col))
                   (->>
                    (coltype-model/collection-types (:group_id parent-col) nil)
                    (p/map
                     (fn [coltypes]
                       (let [collection-type-id (:collection_type_id parent-col)
                             coltype (first (filter #(= (:id %) collection-type-id) coltypes))]
                         (reset! collection-type coltype)
                         (reset! *collection {:id (or collection-id parent-collection-id)
                                              :name (or collection-name (:name @parent-collection))
                                              :collection_type coltype
                                              :data (:data parent-col)})
                         (->> (p/all [(collection-model/permitted-users {:include-contacts true} (:group_id parent-col))
                                      (collection-model/role-list)])
                              (p/map
                               (fn [[permitted-users roles]]
                                 (let [data-sources (coltype-template-data-sources *collection (catom permitted-users) (catom roles))]
                                   (reset! *data-sources data-sources)
                                   (controller/dispatch
                                    :collection-type-form-def
                                    :load-with-callback
                                    {:collection-type-id collection-type-id
                                     :on-success (fn [fd]
                                                   (reset! form-def fd)
                                                   (let [all-flattened-fields (coltype-model/flatten-fields (apply concat (map :fields (:forms @form-def))))
                                                         fields-needing-objects (filter
                                                                                 (fn [fld]
                                                                                   (and
                                                                                    (not-empty (:loader_ref fld))
                                                                                    (contains?
                                                                                     suggested-field-refs
                                                                                     (keyword (:ref fld)))))
                                                                                 all-flattened-fields)]
                                                     (reset! *all-flattened-fields all-flattened-fields)
                                                     (swap! structured-data2 (fn [current-structured-data]
                                                                               (merge current-structured-data
                                                                                      (into {}
                                                                                            (apply concat
                                                                                                   (map (fn [fld]
                                                                                                          (let [field-values (set (current-structured-data (keyword (:ref fld))))]
                                                                                                            [[(keyword (str (:ref fld) "_objects"))
                                                                                                              (into {}
                                                                                                                    (for [[id object-info] @(data-sources (keyword (:loader_ref fld)))
                                                                                                                          :when (contains? field-values id)]
                                                                                                                      [(-> id str keyword) (:object object-info)]))]]))
                                                                                                        fields-needing-objects))))))
                                                     ;; Populate objects for collection-type fields whose IDs are in structured-data2
                                                     ;; but have no _objects (e.g. identity_of_lender_collection)
                                                     (let [collection-fields-needing-objects
                                                           (filter (fn [fld]
                                                                     (and (= "collection" (:type fld))
                                                                          (contains? suggested-field-refs (keyword (:ref fld)))
                                                                          (let [ids (get @structured-data2 (keyword (:ref fld)))
                                                                                objects-key (keyword (str (:ref fld) "_objects"))]
                                                                            (and (seq ids)
                                                                                 (empty? (get @structured-data2 objects-key))))))
                                                                   all-flattened-fields)
                                                           all-collection-ids (distinct (mapcat #(get @structured-data2 (keyword (:ref %))) collection-fields-needing-objects))]
                                                       (when (seq all-collection-ids)
                                                         (->> (p/all (mapv collection-model/collection-details all-collection-ids))
                                                              (p/map
                                                               (fn [collections]
                                                                 (let [col-by-id (into {} (map (fn [col] [(:id col) col]) collections))
                                                                       build-objects (fn [fld]
                                                                                       (let [ids (get @structured-data2 (keyword (:ref fld)))]
                                                                                         [(keyword (str (:ref fld) "_objects"))
                                                                                          (into {}
                                                                                                (keep (fn [id]
                                                                                                        (when-let [c (col-by-id id)]
                                                                                                          [(keyword (str id))
                                                                                                           {:owner_collection_id (:id c)
                                                                                                            :owner_collection {:id (:id c) :name (:name c)}}]))
                                                                                                      ids))]))
                                                                       objects-map (into {} (map build-objects collection-fields-needing-objects))]
                                                                   (swap! structured-data2 merge objects-map)
                                                                   (swap! *collection update :data merge objects-map))))
                                                              (process-error))))
                                                     (tool-collection/populate-document-objects!
                                                      (tool-collection/get-all-doc-fields @*all-flattened-fields @structured-data2)
                                                      @structured-data2
                                                      (fn [document-field-objects-map]
                                                        (swap! structured-data2 merge document-field-objects-map)
                                                        (swap! *collection assoc :data document-field-objects-map)))))}))))
                              (process-error))))))))
                (process-error))
             fields-tree (r/track! #(apply concat (map :fields (:forms @form-def))))
             field-ref-to-segment-index (r/track! (fn []
                                                    (into {} (apply concat (map-indexed (fn [index {fields :fields}]
                                                                                          (map (fn [fld] [(:ref fld) index]) (coltype-model/flatten-fields fields true))) (:forms @form-def))))))
             side-panel-close (atom nil)
             field-status (atom {})
             _ (add-watch structured-data2
                          :flip-status-watch
                          (fn [_ _ oldv newv]
                            (let [[_ changed _] (diff oldv newv)]
                              (swap! field-status merge
                                     (into {}
                                           (map (fn [ref]
                                                  [(name ref) :status/pending])
                                                (keys changed)))))))
             active-form (atom nil)
             reviewed-field-count (r/track! (fn [] (count (filter (fn [[_ status]] (contains? #{:status/approved :status/rejected} status)) @field-status))))
             get-segment-field-status (fn [index]
                                        (let [fields (:fields (nth (:forms @form-def) index))
                                              fields (filter (fn [fld] (contains? suggested-field-refs (keyword (:ref fld)))) fields)]
                                          (into {} (map (fn [fld]
                                                          [(:ref fld) (@field-status (:ref fld))])
                                                        fields))))
             sidebar-form-visible (atom false)
             open-form (fn []
                         (->>
                          (group-admin-permitted-users {:include-contacts true} @family-id)
                          (p/map (fn [group-permitted-users]
                                   (let [[remove _] (add-sidebar-panel
                                                     *sidebar-panels
                                                     nil
                                                     :collection-add
                                                     "Update Collection"
                                                     [collection-edit-sidebar-panels
                                                      (dissoc options :*sidebar-panels)
                                                      (fn [form-index]
                                                        [:div
                                                         [collection-type-form
                                                          {:hide-form-labels true
                                                           :hide-continue-button true
                                                           :active-form form-index
                                                           :collection @*collection
                                                           :errors-atom (atom {})
                                                           :data-sources @*data-sources
                                                           :add_contact_user (partial contact-user-add (catom group-permitted-users) @family-id)
                                                           :forms-change-status-atom (catom {})
                                                           :permitted-groups @*permitted-groups}
                                                          @form-def
                                                          structured-data2]])

                                                      @form-def
                                                      active-form])]
                                     (reset! sidebar-form-visible true)
                                     (reset! side-panel-close remove))))
                          (process-error)))

             _ (register-confirm-action-fn (fn []
                                             (let [all-value-atoms (coltype-component/get-value-atoms structured-data2 @*all-flattened-fields)
                                                   to-value-by-ref (coltype-component/get-to-value-by-ref @*all-flattened-fields)
                                                   flattened-values (coltype-component/flatten-map-values-that-are-maps
                                                                     (into {} (map (fn [[k v]] [k ((to-value-by-ref k) @v)])) all-value-atoms))]
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args (assoc args
                                                              :details (into {}
                                                                             (map (fn [[k v]]
                                                                                    [k (cond
                                                                                         (coll? v) v
                                                                                         (nil? v) []
                                                                                         :else [v])])
                                                                                  (filter (fn [[k _]]
                                                                                            (and (not (str/ends-with? (name k) "_objects"))
                                                                                                 (or (suggested-field-key? suggested-field-refs (name k))
                                                                                                     (contains? @*user-edited-refs (keyword (name k))))))
                                                                                          flattened-values))))
                                                 :success-cb (fn [_]
                                                               (tool-update-success-cb)
                                                               (reset! sidebar-form-visible false)
                                                               (reset! *sidebar-open false)
                                                               (when @side-panel-close (@side-panel-close)))}))))]

    [:div
     (when (and @collection-type @form-def)
       [:div.c-chat-collection-details
        (let [field-ref-count (count (:details args))]
          [:div
           [:h2 (or collection-name (:name @parent-collection))]
           [:p (coltype-model/collection-type-name @collection-type)]
           [:p
            [:span.c-title-counter  field-ref-count " Suggesstions"] " "]])
        [coltype/collection-coltype-details
         {:skip-loading-form-def true
          :form-def form-def
          :form-segment-class :c-chat-collection-details-form-segment
          :form-field-class :c-chat-collection-details-form-field
          :field-class :chat-field-value
          :disable-collapsible true
          :field-controls (fn [field-ref] [field-controls
                                           {:approve-cb (fn []
                                                          (swap! field-status merge
                                                                 (into {} (map (fn [ref] [ref :status/approved]) (retrieve-fields @fields-tree field-ref)))))
                                            :reject-cb (fn []
                                                         (swap! field-status assoc field-ref :status/rejected))
                                            :edit-cb (fn []
                                                       (when-not @sidebar-form-visible (open-form))
                                                       (reset! active-form (@field-ref-to-segment-index field-ref))
                                                       (reset! *sidebar-open true))}
                                           field-ref])
          :form-segment-header-extra-content (fn [segment-index] [segment-header nil (get-segment-field-status segment-index)])
          :base-data (when collection-id (@parent-collection :data))}
         {:id 0
          :collection_type_id (:id @collection-type)
          :collection_type @collection-type
          :name (or collection-name (:name @parent-collection))
          :data (into {} (filter
                          (fn [[ref _]] (suggested-field-key? suggested-field-refs (name ref)))
                          @structured-data2))}]])]))

(defn set-collection-status [{:keys [*sidebar-panels
                                     *disabled
                                     *selected-family-id
                                     register-confirm-action-fn
                                     tool-update-success-cb]
                              :as options}
                             system-message-obj
                             {{:as args} :arguments
                              :as tool-call}]
  (let [{:keys [collection_id collection_name active]} args
        status-text (if active "active" "inactive")]
    (with-let [_ (register-confirm-action-fn (fn []
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args args
                                                 :success-cb tool-update-success-cb})))]
      [:div
       [:div "Collection " [:strong collection_name] " will be set as " [:strong status-text]]])))

(defn- get-all-refs
  "Recursively collects the :ref of a field and all its sub-fields into a flat list."
  [field]
  (when field
    (cons (:ref field)
          (mapcat get-all-refs (:subfields field)))))

(defn- find-field-by-ref
  "Recursively searches through a collection of fields to find the first
  one with a matching :ref value."
  [fields target-ref]
  (reduce
   (fn [_ field]
     (if (= (:ref field) target-ref)
       (reduced field)
       (when-let [found-in-sub (find-field-by-ref (:subfields field) target-ref)]
         (reduced found-in-sub))))
   nil
   fields))

(defn retrieve-fields
  "Given a collection of fields and a starting :ref, finds the matching
  field and returns a flat vector of its :ref and all its descendant :refs.
  Returns an empty vector if the ref is not found."
  [fields-data start-ref]
  (if-let [starting-field (find-field-by-ref fields-data start-ref)]
    (vec (get-all-refs starting-field))
    []))

(defn update-collection-ownership [{:keys [*sidebar-panels
                                           *disabled
                                           *selected-family-id
                                           register-confirm-action-fn
                                           tool-update-success-cb]
                                    :as options}
                                   system-message-obj
                                   {{:as args} :arguments
                                    :as tool-call}]
  (let [{:keys [collection_id
                ownership_unit
                entity_documents
                ownerships]} args]
    (with-let [*form-def (atom nil)
               *collection (atom nil)
               *fields (atom nil)
               *data-sources (atom nil)
               *common-options (atom nil)
               *input (atom args)
               *values (l/derive tool-collection/ownership-lens *input)
               *all-flattened-fields (atom nil)
               *permitted-groups (atom nil)
               _ (register-confirm-action-fn (fn []
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args (dissoc
                                                        (update @*input :ownerships
                                                                (fn [ownerships]
                                                                  (map (fn [ownership]
                                                                         (dissoc ownership :object))
                                                                       ownerships)))
                                                        :entity_document_objects)
                                                 :success-cb tool-update-success-cb})))
               ;; Pre-load owner-collection objects so the UI can display names.
               ;; Contact entries (owner_user_id) have no owner_collection_id — skip
               ;; them, otherwise the failing request rejects the whole p/all and no
               ;; collection owners are rendered at all (#2929).
               _ (->>
                  (p/all (mapv (fn [{owner-collection-id :owner_collection_id}]
                                 (when (and owner-collection-id (not= 0 owner-collection-id))
                                   (collection-model/collection-details owner-collection-id)))
                               ownerships))
                  (p/map (fn [collections]
                           (swap! *values assoc :family_members_objects
                                  (into {} (keep (fn [col]
                                                   (when col
                                                     [(keyword (str (:id col))) {:owner_collection_id (:id col)
                                                                                 :owner_collection {:id (:id col) :name (:name col)}}]))
                                                 collections)))))
                  (process-error))
               _ (add-watch *values :doc-fields-watch
                            (fn [_ _ old-data new-data]
                              (let [changed-doc-fields (filter (fn [field]
                                                                 (not=
                                                                  (old-data (keyword (:ref field)))
                                                                  (new-data (keyword (:ref field)))))
                                                               (tool-collection/get-all-doc-fields @*all-flattened-fields @*values))]
                                (when (seq changed-doc-fields)
                                  (tool-collection/populate-document-objects! changed-doc-fields @*values
                                                                              (fn [document-field-objects-map]
                                                                                (swap! *values merge document-field-objects-map)
                                                                                (swap! *collection assoc :data document-field-objects-map)))))))
               _ (->>
                  (collection-model/collection-full-details collection_id false)
                  (p/map (fn [collection]
                           (reset! *collection collection)
                           (->>
                            (p/all [(collection-model/permitted-users
                                     {:include-contacts true} (:group_id collection))
                                    (collection-model/role-list)
                                    (collection-model/permitted-groups (:group_id collection))])
                            (p/map (fn [[permitted-users roles permitted-groups]]
                                     (reset! *data-sources
                                             (coltype-template-data-sources *collection (catom permitted-users) (catom roles)))
                                     (reset! *permitted-groups permitted-groups))))
                           (controller/dispatch
                            :collection-type-form-def
                            :load-with-callback
                            {:collection-type-id (:collection_type_id collection)
                             :on-success (fn [fd]
                                           (reset! *form-def fd)
                                           (let [ownership-form (first (filter (fn [form] (= "Ownership" (:label form))) (:forms fd)))
                                                 all-flattened-fields (coltype-model/flatten-fields (apply concat (map :fields (:forms fd))))
                                                 ref-field-map (util/associate-by :ref all-flattened-fields)
                                                 ownership-field (first (filter (fn [field] (= "ownership" (:type field))) (:fields ownership-form)))
                                                 collection-field (ref-field-map (:collection_ownership_field_ref ownership-field))
                                                 users-field (ref-field-map (:user_ownership_field_ref ownership-field))
                                                 unit-selector-field (ref-field-map (:unit_selector_field_ref ownership-field))
                                                 _ (reset! *all-flattened-fields all-flattened-fields)
                                                 _ (reset! *fields
                                                           {:ownership ownership-field
                                                            ;; :unit-selector is StaticField ("static" type, no component) — intentionally omitted
                                                            :ownership-documents (get ref-field-map "ownership_document")
                                                            :collection collection-field
                                                            :users users-field})
                                                 _ (reset! *common-options
                                                           {:value-atoms (coltype-component/get-value-atoms *values
                                                                                                            all-flattened-fields)
                                                            :form-fields all-flattened-fields
                                                            :all-segment-ref-field-map (util/associate-by :ref all-flattened-fields)
                                                            :deleted-value-atom (atom #{})
                                                            :rerender-atom (atom false)
                                                            :shared-atoms (into {} (map (fn [field] [(:ref field) (atom nil)]) all-flattened-fields))})]
                                             (tool-collection/populate-document-objects!
                                              (tool-collection/get-all-doc-fields all-flattened-fields @*values)
                                              @*values
                                              (fn [document-field-objects-map]
                                                (swap! *values merge document-field-objects-map)
                                                (swap! *collection assoc :data document-field-objects-map)))))})))
                  (process-error))]
      [:div
       (when (and
              @*common-options
              @*data-sources)
         (let [objects (coltype-component/get-field-objects-map @*all-flattened-fields  @*values)]
           (doall
            (for [field-key [:ownership-documents
                             :ownership
                             ;; :unit-selector is a StaticField (fixed value, no form component) — skip it
                             :collection
                             :users]
                  :let [field (@*fields field-key)]
                  :when field]
              [:div {:key (:ref field)}
               (when-not (contains? #{"label" "bool"} (:type field))
                 [:h4.u-margin-bottom
                  (:label field)])
               (when (:note field) [:div.c-note (:note field)])
               (let [form-field-options (merge
                                         @*common-options
                                         {:objects objects
                                          :collection {:id collection_id
                                                       :group_id (:group_id @*collection)
                                                       :data @*values}
                                          :permitted-groups @*permitted-groups
                                          :shared-atom (get-in @*common-options [:shared-atoms (:ref field)])
                                          :value-atom (get-in @*common-options [:value-atoms (:ref field)])
                                          :skip-change-atom (catom false)
                                          :data-sources @*data-sources
                                          :add_contact_user (fn [] [:div])
                                          :errors-atom (atom {})})]
                 [coltype-component/form-field
                  form-field-options field])]))))])))

(defn update-collection-carried-interest-ownership
  [{:keys [*sidebar-panels
           *disabled
           *selected-family-id
           register-confirm-action-fn
           tool-update-success-cb]
    :as options}
   system-message-obj
   {{:as args} :arguments
    :as tool-call}]
  (let [{:keys [collection_id
                entity_documents
                use_percentage
                ownerships]} args]
    (with-let [*form-def (atom nil)
               *collection (atom nil)
               *fields (atom nil)
               *data-sources (atom nil)
               *common-options (atom nil)
               *input (atom args)
               *values (l/derive tool-collection/carried-interest-lens *input)
               *all-flattened-fields (atom nil)
               *permitted-groups (atom nil)
               _ (register-confirm-action-fn
                  (fn []
                    (controller/dispatch
                     :chat-tool-call
                     :update-args
                     {:tool-call-id (:id tool-call)
                      :args (dissoc
                             (update @*input :ownerships
                                     (fn [ownerships]
                                       (map (fn [o] (dissoc o :object)) ownerships)))
                             :entity_document_objects)
                      :success-cb tool-update-success-cb})))
               ;; Pre-load owner-collection objects so the UI can display names
               _ (->>
                  (p/all (mapv (fn [{owner-collection-id :owner_collection_id}]
                                 (when owner-collection-id
                                   (collection-model/collection-details owner-collection-id)))
                               ownerships))
                  (p/map (fn [collections]
                           (swap! *values assoc :carried_interest_family_members_objects
                                  (into {}
                                    (keep (fn [col]
                                            (when col
                                              [(keyword (str (:id col)))
                                               {:owner_collection_id (:id col)
                                                :owner_collection {:id (:id col) :name (:name col)}}]))
                                          collections)))))
                  (process-error))
               _ (->>
                  (collection-model/collection-full-details collection_id false)
                  (p/map
                   (fn [collection]
                     (reset! *collection collection)
                     (->>
                      (p/all [(collection-model/permitted-users
                               {:include-contacts true} (:group_id collection))
                              (collection-model/role-list)
                              (collection-model/permitted-groups (:group_id collection))])
                      (p/map (fn [[permitted-users roles permitted-groups]]
                               (reset! *data-sources
                                       (coltype-template-data-sources *collection (catom permitted-users) (catom roles)))
                               (reset! *permitted-groups permitted-groups))))
                     (controller/dispatch
                      :collection-type-form-def
                      :load-with-callback
                      {:collection-type-id (:collection_type_id collection)
                       :on-success
                       (fn [fd]
                         (reset! *form-def fd)
                         (let [carried-interest-form (first (filter (fn [form] (= "Carried Interest" (:label form))) (:forms fd)))
                               all-flattened-fields (coltype-model/flatten-fields (apply concat (map :fields (:forms fd))))
                               ref-field-map (util/associate-by :ref all-flattened-fields)
                               ;; The ownership-type field inside the Carried Interest form segment
                               ci-ownership-field (first (filter (fn [f] (= "ownership" (:type f))) (:fields carried-interest-form)))]
                           (reset! *all-flattened-fields all-flattened-fields)
                           (reset! *fields
                                   {:ownership-documents   (ref-field-map "carried_interest_document")
                                    :use-percentage        (ref-field-map "carried_interest_use_percentage")
                                    :ownership             ci-ownership-field
                                    ;; :unit-selector is StaticField ("static" type, no component) — intentionally omitted
                                    :collection            (when ci-ownership-field
                                                             (ref-field-map (:collection_ownership_field_ref ci-ownership-field)))
                                    :users                 (when ci-ownership-field
                                                             (ref-field-map (:user_ownership_field_ref ci-ownership-field)))})
                           (reset! *common-options
                                   {:value-atoms (coltype-component/get-value-atoms *values all-flattened-fields)
                                    :form-fields all-flattened-fields
                                    :all-segment-ref-field-map (util/associate-by :ref all-flattened-fields)
                                    :deleted-value-atom (atom #{})
                                    :rerender-atom (atom false)
                                    :shared-atoms (into {} (map (fn [field] [(:ref field) (atom nil)]) all-flattened-fields))})
                           (tool-collection/populate-document-objects!
                            (tool-collection/get-all-doc-fields all-flattened-fields @*values)
                            @*values
                            (fn [document-field-objects-map]
                              (swap! *values merge document-field-objects-map)
                              (swap! *collection assoc :data document-field-objects-map)))))})))
                  (process-error))]
      [:div
       (when (and @*common-options @*data-sources)
         (let [objects (coltype-component/get-field-objects-map @*all-flattened-fields @*values)]
           (doall
                          (for [field-key [:ownership-documents
                                         :use-percentage
                                         ;; :unit-selector is a StaticField (always "percentage") — no :component in field-types, skip it
                                         :ownership
                                         :collection
                                         :users]
                              :let [field (@*fields field-key)]
                              :when field]
                          [:div {:key (:ref field)}
                           (when-not (contains? #{"label" "bool"} (:type field))
                             [:h4.u-margin-bottom (:label field)])
                           (when (:note field) [:div.c-note (:note field)])
                           (let [form-field-options (merge
                                                     @*common-options
                                                     {:objects objects
                                                      :collection {:id collection_id
                                                                   :group_id (:group_id @*collection)
                                                                   :data @*values}
                                                      :permitted-groups @*permitted-groups
                                                      :shared-atom (get-in @*common-options [:shared-atoms (:ref field)])
                                                      :value-atom (get-in @*common-options [:value-atoms (:ref field)])
                                                      :skip-change-atom (catom false)
                                                      :data-sources @*data-sources
                                                      :add_contact_user (fn [] [:div])
                                                      :errors-atom (atom {})})]
                             [coltype-component/form-field form-field-options field])]))))])))
            
(defn update-collection-trust-beneficial-interest
  [{:keys [*sidebar-panels
           *disabled
           *selected-family-id
           register-confirm-action-fn
           tool-update-success-cb]
    :as options}
   system-message-obj
   {{:as args} :arguments
    :as tool-call}]
  (let [{:keys [collection_id
                entity_documents
                primary_ownerships
                secondary_ownerships]} args
        all-ownerships (concat (or primary_ownerships []) (or secondary_ownerships []))]
    (with-let [*form-def (atom nil)
               *collection (atom nil)
               *fields (atom nil)
               *data-sources (atom nil)
               *common-options (atom nil)
               *input (atom args)
               *values (l/derive tool-collection/trust-beneficial-interest-lens *input)
               *all-flattened-fields (atom nil)
               *permitted-groups (atom nil)
               _ (register-confirm-action-fn
                  (fn []
                    (controller/dispatch
                     :chat-tool-call
                     :update-args
                     {:tool-call-id (:id tool-call)
                      :args (->
                             (update @*input :primary_ownerships
                                     (fn [ownerships]
                                       (map (fn [o] (dissoc o :object)) ownerships)))
                             (update :secondary_ownerships
                                     (fn [ownerships]
                                       (map (fn [o] (dissoc o :object)) ownerships)))
                             (dissoc :entity_document_objects))
                      :success-cb tool-update-success-cb})))
               ;; Pre-load owner-collection objects for both primary and secondary ownerships
               _ (->>
                  (p/all (mapv (fn [{owner-collection-id :owner_collection_id}]
                                 (when owner-collection-id
                                   (collection-model/collection-details owner-collection-id)))
                               all-ownerships))
                  (p/map (fn [collections]
                           (let [objects (into {}
                                          (keep (fn [col]
                                                  (when col
                                                    [(keyword (str (:id col)))
                                                     {:owner_collection_id (:id col)
                                                      :owner_collection {:id (:id col) :name (:name col)}}]))
                                                collections))]
                             (swap! *values assoc
                                    :primary_family_beneficiaries_objects objects
                                    :secondary_family_beneficiaries_objects objects))))
                  (process-error))
               _ (->>
                  (collection-model/collection-full-details collection_id false)
                  (p/map
                   (fn [collection]
                     (reset! *collection collection)
                     (->>
                      (p/all [(collection-model/permitted-users
                               {:include-contacts true} (:group_id collection))
                              (collection-model/role-list)
                              (collection-model/permitted-groups (:group_id collection))])
                      (p/map (fn [[permitted-users roles permitted-groups]]
                               (reset! *data-sources
                                       (coltype-template-data-sources *collection (catom permitted-users) (catom roles)))
                               (reset! *permitted-groups permitted-groups))))
                     (controller/dispatch
                      :collection-type-form-def
                      :load-with-callback
                      {:collection-type-id (:collection_type_id collection)
                       :on-success
                       (fn [fd]
                         (reset! *form-def fd)
                         (let [beneficiaries-form (first (filter (fn [form] (= "Beneficiaries" (:label form))) (:forms fd)))
                               all-flattened-fields (coltype-model/flatten-fields (apply concat (map :fields (:forms fd))))
                               ref-field-map (util/associate-by :ref all-flattened-fields)
                               ownership-fields (filter (fn [f] (= "ownership" (:type f))) (:fields beneficiaries-form))
                               primary-ownership-field   (first (filter (fn [f] (= "primary_ownership" (:ref f))) ownership-fields))
                               secondary-ownership-field (first (filter (fn [f] (= "secondary_ownership" (:ref f))) ownership-fields))]
                           (reset! *all-flattened-fields all-flattened-fields)
                           (reset! *fields
                                   {:primary-ownership         primary-ownership-field
                                    :primary-collection        (when primary-ownership-field
                                                                 (ref-field-map (:collection_ownership_field_ref primary-ownership-field)))
                                    :primary-users             (when primary-ownership-field
                                                                 (ref-field-map (:user_ownership_field_ref primary-ownership-field)))
                                    :secondary-ownership       secondary-ownership-field
                                    :secondary-collection      (when secondary-ownership-field
                                                                 (ref-field-map (:collection_ownership_field_ref secondary-ownership-field)))
                                    :secondary-users           (when secondary-ownership-field
                                                                 (ref-field-map (:user_ownership_field_ref secondary-ownership-field)))})
                           (reset! *common-options
                                   {:value-atoms (coltype-component/get-value-atoms *values all-flattened-fields)
                                    :form-fields all-flattened-fields
                                    :all-segment-ref-field-map (util/associate-by :ref all-flattened-fields)
                                    :deleted-value-atom (atom #{})
                                    :rerender-atom (atom false)
                                    :shared-atoms (into {} (map (fn [field] [(:ref field) (atom nil)]) all-flattened-fields))})))})))
                  (process-error))]
      [:div
       (when (and @*common-options @*data-sources)
         (let [objects (coltype-component/get-field-objects-map @*all-flattened-fields @*values)]
           (doall
            (for [field-key [:primary-ownership
                             :primary-collection
                             :primary-users
                             :secondary-ownership
                             :secondary-collection
                             :secondary-users]
                  :let [field (@*fields field-key)]
                  :when field]
              [:div {:key (:ref field)}
               (when-not (contains? #{"label" "bool"} (:type field))
                 [:h4.u-margin-bottom (:label field)])
               (when (:note field) [:div.c-note (:note field)])
               (let [form-field-options (merge
                                         @*common-options
                                         {:objects objects
                                          :collection {:id collection_id
                                                       :group_id (:group_id @*collection)
                                                       :data @*values}
                                          :permitted-groups @*permitted-groups
                                          :shared-atom (get-in @*common-options [:shared-atoms (:ref field)])
                                          :value-atom (get-in @*common-options [:value-atoms (:ref field)])
                                          :skip-change-atom (catom false)
                                          :data-sources @*data-sources
                                          :add_contact_user (fn [] [:div])
                                          :errors-atom (atom {})})]
                 [coltype-component/form-field form-field-options field])]))))])))

(defn batch-permissions-modal [options family-id *parent-id *batch-permitted-user-ids]
  (let [*permitted-user-ids (atom #{})
        close-fn (fn []
                   (swap! state/modals update :batch-create :enabled :false))]
    [:div
     [:div.cs-modal-batch-permissions__wrapper
      [permissions (assoc options
                          :batch-create true) family-id *parent-id *permitted-user-ids]]
     [:div.cs-modal-footer.batch-permissions
      [:button.c-button--wide.c-button--outlined
       {:on-click (util/handler (fn []
                                  (reset! *permitted-user-ids #{})
                                  (close-fn)))} "Close"]
      [:button.c-button--wide.u-margin-left
       {:on-click (util/handler (fn []
                                  (reset! *batch-permitted-user-ids @*permitted-user-ids)
                                  (close-fn)))} "Save"]]]))

(defn create-collection-group [tool-fn options tc-group message-obj]
  (with-let [*parent-id-atoms (into {} (map (fn [tc] [(util/somestr-to-int (:id tc)) (atom (get-in tc [:arguments :parent_id]))]) tc-group))
             *batch-permitted-user-ids (atom #{})
             *batch-parent-id (atom (first (disj (set (map deref (vals *parent-id-atoms))))))
             *family-ids (atom (into {} (keep (fn [tc]
                                               (when-not (get-in tc [:arguments :parent_id])
                                                 [(:id tc) nil]))
                                             tc-group)))
             hide-populate-from-parent (fn []
                                         (or (not (= 1 (count (set (map deref (vals *parent-id-atoms))))))
                                             (contains? (set (vals @*family-ids)) @*batch-parent-id)))
             _ (doseq [[parent-id tcs-for-parent] (group-by #(get-in % [:arguments :parent_id])
                                                            (filter #(get-in % [:arguments :parent_id]) tc-group))]
                 (controller/dispatch :collection-details :load
                                      {:collection-id parent-id
                                       :on-success    (fn [parent-collection]
                                                        (swap! *family-ids into
                                                               (map (fn [tc] [(:id tc) (:group_id parent-collection)])
                                                                    tcs-for-parent)))}))]
    (let [batch-create (and (> (count tc-group) 1)
                            (= 1 (count (disj (set (vals @*family-ids)) nil))))]
      [:<>
       (when batch-create
         [:div.o-space-between.u-margin-bottom
          [:div
           [:h2 (str "Create " (count tc-group) " collections")]]
          [:div
           [:button.c-button--outlined {:on-click (util/handler
                                                   (fn []
                                                     (common/show-modal :batch-create
                                                                        [batch-permissions-modal (assoc options
                                                                                                        :hide-populate-from-parent (hide-populate-from-parent)) (first (vals @*family-ids))  *batch-parent-id *batch-permitted-user-ids]
                                                                        {:modal-class "cs-modal-batch-permissions"})))}
            "Set permissions for all"]]])
       (when (= (count @*family-ids) (count tc-group))
         (doall
          (for [tc tc-group
                :let [setup-confirm-action (fn [confirm-cb]
                                             (swap! (:*confirm-actions options) assoc (:id tc) confirm-cb))
                      family-id (get @*family-ids (:id tc))]]
            ^{:key (:id tc)}
            [tool-fn (assoc options
                            :register-confirm-action-fn setup-confirm-action
                            :batch-create batch-create
                            :*batch-permitted-user-ids *batch-permitted-user-ids
                            :*parent-id-atoms *parent-id-atoms
                            :family-id family-id) message-obj tc])))])))

;; --- Collection Review ---

(def cadence-labels
  {"quarterly"     "Quarterly (every 3 months)"
   "semi-annually" "Semi-annually (every 6 months)"
   "annually"      "Annually (once per year)"
   "custom"        "Custom frequency"})

(defn create-cadence-compliance [{:keys [register-confirm-action-fn
                                         tool-update-success-cb]
                                   :as options}
                                  system-message-obj
                                  {{collection-id :collection_id
                                    cadence       :cadence} :arguments
                                   :as tool-call}]
  (with-let [*collection-name (atom nil)
             _ (->> (collection-model/collection-details collection-id)
                    (p/map (fn [col] (reset! *collection-name (:name col))))
                    (process-error))
             _ (register-confirm-action-fn tool-update-success-cb)]
    [:div.o-media--margin
     [:p "Create a recurring review reminder for this collection?"]
     [:ul
      [:li [:strong "Collection: "] (or @*collection-name "…")]
      [:li [:strong "Cadence: "] (get cadence-labels cadence cadence)]]]))

(def severity-options
  [{:value "high" :label "High"}
   {:value "medium" :label "Medium"}
   {:value "low" :label "Low"}])

(def resolution-options
  [{:value "action_item" :label "Action Item"}
   {:value "exception" :label "Exception"}
   {:value "not_applicable" :label "Not Applicable"}])

(defn- severity-class [severity]
  (case severity
    "high"   "review-finding__severity--high"
    "medium" "review-finding__severity--medium"
    "low"    "review-finding__severity--low"
    ""))

(defn- review-finding-card [finding-index *findings save-draft-fn]
  (let [finding (nth @*findings finding-index)
        *expanded (atom false)
        *exemption-pending (atom false)
        *pre-edit-state (atom nil)]
    (fn [finding-index *findings save-draft-fn]
      (let [finding (nth @*findings finding-index)
            update-finding! (fn [k v]
                              (swap! *findings assoc-in [finding-index k] v))
            start-exemption! (fn [resolution]
                               (update-finding! :resolution resolution)
                               (reset! *exemption-pending true))
            cancel-exemption! (fn []
                                (if-let [prior @*pre-edit-state]
                                  (do (update-finding! :resolution (:resolution prior))
                                      (update-finding! :rationale (:rationale prior)))
                                  (do (update-finding! :resolution "action_item")
                                      (update-finding! :rationale nil)))
                                (reset! *pre-edit-state nil)
                                (reset! *exemption-pending false)
                                (save-draft-fn))
            confirm-exemption! (fn []
                                 (reset! *pre-edit-state nil)
                                 (reset! *exemption-pending false)
                                 (save-draft-fn))]
        [:div.review-finding
         {:class (str (when (:auto_applied finding) " review-finding--auto-applied")
                      (when @*expanded " review-finding--expanded"))}
         ;; Header row: status icon + severity badge + title + expand toggle
         [:div.review-finding__header
          {:on-click #(swap! *expanded not)}
          [:img.review-finding__status-icon
           {:src "/static/img/icons/review-xcircle.svg"
            :class (case (:resolution finding)
                    "exception"      "review-finding__status-icon--exception"
                    "not_applicable" "review-finding__status-icon--na"
                    "review-finding__status-icon--fail")}]
          [:span.review-finding__severity
           {:class (severity-class (:severity finding))}
           (str/capitalize (:severity finding))]
          [:span.review-finding__title (:title finding)]
          [:img.review-finding__toggle
           {:src "/static/img/icons/review-chevron.svg"
            :class (when @*expanded "review-finding__toggle--expanded")}]]

         ;; Category line
         (when (not-empty (:category finding))
           [:div.review-finding__category
            "Category: " (:category finding)])

         ;; Auto-applied indicator
         (when (:auto_applied finding)
           [:div.review-finding__auto-applied
            "Carried forward from prior review"
            (when-let [d (:auto_applied_date finding)]
              (str " on " d))])

         ;; Expanded detail
         (when @*expanded
           [:div.review-finding__detail
            ;; Description
            (when (not-empty (:description finding))
              [:div.review-finding__description (:description finding)])

            ;; Controls row: severity + resolution toggles
            [:div.review-finding__controls-row
             ;; Severity dropdown
             [:div.review-finding__severity-control
              [:select.review-finding__severity-select
               {:value (:severity finding)
                :on-change (fn [e]
                             (update-finding! :severity (-> e .-target .-value))
                             (save-draft-fn))}
               (for [{:keys [value label]} severity-options]
                 ^{:key value}
                 [:option {:value value} label])]]
             ;; Resolution toggles
             [:div.review-finding__resolution-buttons
              (for [{:keys [value label]} resolution-options]
                ^{:key value}
                [:button.review-finding__resolution-btn
                 {:class (when (= (:resolution finding) value)
                           "review-finding__resolution-btn--active")
                  :on-click (fn []
                              (if (contains? #{"exception" "not_applicable"} value)
                                (start-exemption! value)  ;; save deferred to confirm/cancel
                                (do (update-finding! :resolution value)
                                    (update-finding! :rationale nil)
                                    (reset! *exemption-pending false)
                                    (save-draft-fn))))}
                 label])]]])

         ;; Exemption area (edit or read-only)
         (when (contains? #{"exception" "not_applicable"} (:resolution finding))
           (let [editing? @*exemption-pending
                 is-exception? (= (:resolution finding) "exception")]
             (if editing?
               ;; Editable exemption box
               [:div.review-finding__exemption-box
                [:div.review-finding__exemption-header
                 [:span.review-finding__exemption-title
                  (if is-exception? "Mark as Exception" "Mark as Not Applicable")]
                 [:span.review-finding__exemption-hint
                  (if is-exception?
                    "This finding will be moved to the Exceptions tab. Please provide a reason for the exception."
                    "This finding will be removed from the action items. Please provide a reason.")]]
                [:input.review-finding__exemption-input
                 {:type "text"
                  :placeholder "Enter rationale..."
                  :value (or (:rationale finding) "")
                  :on-change #(update-finding! :rationale
                                               (let [v (-> % .-target .-value)]
                                                 (when (not-empty v) v)))
                  :on-key-down #(when (= (.-key %) "Enter")
                                  (confirm-exemption!))}]
                [:div.review-finding__exemption-actions
                 [:button.review-finding__exemption-cancel
                  {:on-click cancel-exemption!}
                  "Cancel"]
                 [:button.review-finding__exemption-confirm
                  {:on-click confirm-exemption!}
                  "Confirm"]]]
               ;; Read-only display
               [:div.review-finding__exemption-display
                [:div.review-finding__exemption-display-label
                 (if is-exception? "Exception" "Not Applicable")]
                (when (not-empty (:rationale finding))
                  [:div.review-finding__exemption-display-text
                   (:rationale finding)])
                [:button.review-finding__exemption-edit
                 {:on-click (fn []
                              (reset! *pre-edit-state {:resolution (:resolution finding)
                                                       :rationale  (:rationale finding)})
                              (reset! *exemption-pending true))}
                 "Edit"]])))]))))

;; Mirrors collection.ComputeFindingCounts in server/collection/review.go
;; (#2988) — the single set of formulas for every review counter. The panel has
;; to compute locally rather than read the server's numbers, because the reviewer
;; edits dispositions in the confirmation form and the counters must follow each
;; edit. Keep the two in step: the server's result is what the PDF and the stored
;; row carry.
;;
;; Non-compliant counts only findings still open as action items; a finding
;; dispositioned as an exception or as not applicable has been resolved.
;; Compliant is the length of the compliant-items list, and items-reviewed is
;; that plus the findings. The severity counters of the Go original have no
;; mirror here: the panel renders severity as lists of findings, never as a
;; number.
(defn- review-counts [findings compliant-items]
  (let [by-resolution (fn [r] (count (filterv #(= (:resolution %) r) findings)))
        exceptions (by-resolution "exception")
        not-applicable (by-resolution "not_applicable")
        findings-count (count findings)
        compliant (count compliant-items)]
    {:findings findings-count
     :non-compliant (- findings-count exceptions not-applicable)
     :exceptions exceptions
     :not-applicable not-applicable
     :dispositioned (+ exceptions not-applicable)
     :compliant compliant
     :items-reviewed (+ compliant findings-count)}))

(defn- review-header-meta-item [icon-src label value]
  [:<>
   [:div.review-header__meta-item
    [:img.review-header__meta-icon {:src icon-src}]
    [:div.review-header__meta-text
     [:span.review-header__meta-label label]
     [:span.review-header__meta-value value]]]])

(defn- review-header [{:keys [collection_name lmp_name lmp_version
                              generated_by_name last_reviewed_date]} on-discard discarding?]
  (let [today (.toISOString (js/Date.))
        date-str (or last_reviewed_date (subs today 0 10))
        title (str "Collection Review - " (or collection_name "") " - " date-str)]
    [:div.review-header
     ;; Title row
     [:div.review-header__title-row
      [:img.review-header__icon {:src "/static/img/icons/review-report.svg"}]
      [:h2.review-header__title title]
      (when on-discard
        [:div.review-header__discard
         [util/disable-tool
          {:disabled  discarding?
           :class     :u-non-clickable
           :component [:button.c-button--small.c-button--danger
                       {:on-click (util/handler on-discard)}
                       "Discard review"]}]])]
     ;; Metadata row
     [:div.review-header__meta
      [review-header-meta-item "/static/img/icons/review-user.svg" "Generated by" (or generated_by_name "—")]
      [:div.review-header__meta-divider]
      [review-header-meta-item "/static/img/icons/review-calendar.svg" "Last reviewed" (or last_reviewed_date "—")]
      [:div.review-header__meta-divider]
      ;; lmp_name is echoed by the model, which sometimes HTML-escapes it
      ;; (e.g. "&amp;" for "&") — decode entities before display (#3064).
      [review-header-meta-item "/static/img/icons/review-filetext.svg" "Lifecycle plan"
       (str (util/entity (or lmp_name "—"))
            (when (not-empty lmp_version) (str " " lmp_version)))]]
     ;; Disclaimer row
     [:p.review-header__disclaimer
      "AARK™ is AI and can make mistakes. This response is provided for informational purposes only. It does not constitute legal, financial, or professional advice."]]))

(defn- review-tab-badge [count-val active?]
  (when (some? count-val)
    [:span.review-tabs__badge
     {:class (when active? "review-tabs__badge--active")}
     (str count-val)]))

(defn- review-tab-bar [*active-tab *findings]
  (let [{:keys [findings non-compliant dispositioned]} (review-counts @*findings nil)
        ;; The Exceptions tab lists both dispositions, so its badge counts both.
        tabs [{:id :overview     :label "Overview"     :badge nil}
              {:id :findings     :label "Findings"     :badge findings}
              {:id :exceptions   :label "Exceptions"   :badge dispositioned}
              {:id :action-items :label "Action Items"  :badge (when (pos? non-compliant) non-compliant)}]]
    [:div.review-tabs
     (doall
      (for [{:keys [id label badge]} tabs
            :let [active? (= @*active-tab id)]]
        ^{:key id}
        [:button.review-tabs__tab
         {:class (when active? "review-tabs__tab--active")
          :on-click #(reset! *active-tab id)}
         [:span.review-tabs__label label]
         [review-tab-badge badge active?]]))]))

(defn- review-overview-kv-pair [label value]
  [:div.review-overview__kv-pair
   [:span.review-overview__kv-label label]
   [:span.review-overview__kv-value (or value "—")]])

(defn- review-overview-metric [icon-src label value]
  [:div.review-overview__metric
   [:img.review-overview__metric-icon {:src icon-src}]
   [:div.review-overview__metric-text
    [:span.review-overview__metric-label label]
    [:span.review-overview__metric-value (str value)]]])

(defn- review-overview-status-item [icon-src label count-val color-class]
  [:div.review-overview__status-item
   [:div.review-overview__status-header
    [:img.review-overview__status-icon {:src icon-src}]
    [:span {:class (str "review-overview__status-label " color-class)} label]]
   [:span {:class (str "review-overview__status-count " color-class)} (str count-val)]])

(defn- review-overview-working-item [{:keys [title description]}]
  [:div.review-overview__working-item
   [:img.review-overview__working-icon {:src "/static/img/icons/review-checkcircle.svg"}]
   [:div.review-overview__working-text
    [:span.review-overview__working-title title]
    [:span.review-overview__working-desc description]]])

(defn- review-overview-gap-group [severity-label icon-src bg-class findings-list]
  [:div {:class (str "review-overview__gap-group " bg-class)}
   [:div.review-overview__gap-header
    [:img.review-overview__gap-icon {:src icon-src}]
    [:span.review-overview__gap-title severity-label]]
   [:ul.review-overview__gap-list
    (doall
     (for [[i f] (map-indexed vector findings-list)]
       ^{:key i}
       [:li.review-overview__gap-item (:title f)]))]])

(defn- review-tab-overview [*findings {:keys [collection_name collection_type
                                              collection_status parent_collection_name
                                              document_count subcollection_count
                                              pending_task_count pending_compliance_count
                                              compliant_items]
                                       :as args}]
  (let [findings @*findings
        {:keys [exceptions not-applicable non-compliant compliant items-reviewed]}
        (review-counts findings compliant_items)
        compliant-pct (if (pos? items-reviewed)
                        (* 100 (/ compliant items-reviewed))
                        0)
        high-findings (filterv #(= (:severity %) "high") findings)
        medium-findings (filterv #(= (:severity %) "medium") findings)]
    [:div.review-report__tab-content
     [:div.review-overview

      ;; Section 1: Collection Details
      [:div.review-overview__section
       [:div.review-overview__section-heading
        [:img.review-overview__heading-icon {:src "/static/img/icons/review-filetext.svg"}]
        [:span "Collection Details"]]
       [:div.review-overview__kv-grid
        [review-overview-kv-pair "Collection Name" collection_name]
        [review-overview-kv-pair "Parent Collection" parent_collection_name]
        [review-overview-kv-pair "Type" collection_type]
        [review-overview-kv-pair "Status" collection_status]]
       [:div.review-overview__metric-row
        [review-overview-metric "/static/img/icons/review-documents.svg" "Documents" document_count]
        [:div.review-overview__metric-divider]
        [review-overview-metric "/static/img/icons/review-subcollections.svg" "Subcollections" subcollection_count]
        [:div.review-overview__metric-divider]
        [review-overview-metric "/static/img/icons/review-tasks.svg" "Pending Tasks" pending_task_count]
        [:div.review-overview__metric-divider]
        [review-overview-metric "/static/img/icons/review-compliances.svg" "Pending Compliances" pending_compliance_count]]]

      ;; Section 2: Compliance Summary
      [:div.review-overview__section
       [:div.review-overview__section-heading
        [:span "Compliance Summary"]]
       [:div.review-overview__progress-bar
        [:div.review-overview__progress-track
         [:div.review-overview__progress-fill {:style {:width (str compliant-pct "%")}}]]]
       ;; The four dispositions the report prints, plus the total it does not, so
       ;; the two surfaces can be read against each other. Not Applicable is
       ;; listed separately from Exceptions because the tab above counts both
       ;; together — without it on screen the tab's badge and this row would show
       ;; "Exceptions" as two different numbers with no way to reconcile them.
       [:div.review-overview__status-row
        [review-overview-status-item "/static/img/icons/review-findings-search.svg"
         "Items Reviewed" items-reviewed "review-overview__color--findings"]
        [review-overview-status-item "/static/img/icons/review-flag.svg"
         "Exceptions" exceptions "review-overview__color--exceptions"]
        [review-overview-status-item "/static/img/icons/review-alertcircle.svg"
         "Not Applicable" not-applicable "review-overview__color--notapplicable"]
        [review-overview-status-item "/static/img/icons/review-xcircle.svg"
         "Non-Compliant" non-compliant "review-overview__color--noncompliant"]
        [review-overview-status-item "/static/img/icons/review-checkcircle-green.svg"
         "Compliant" compliant "review-overview__color--compliant"]]]

      ;; Section 3: What's Working Well
      (when (seq compliant_items)
        [:div.review-overview__section
         [:div.review-overview__section-heading
          [:span "What's Working Well"]]
         [:div.review-overview__working-list
          (doall
           (for [[i item] (map-indexed vector compliant_items)]
             ^{:key i}
             [review-overview-working-item item]))]])

      ;; Section 4: Key Gaps
      (when (or (seq high-findings) (seq medium-findings))
        [:div.review-overview__section
         [:div.review-overview__section-heading
          [:span "Key Gaps"]]
         [:div.review-overview__gaps-container
          (when (seq high-findings)
            [review-overview-gap-group
             (str (count high-findings) " High Severity Issue" (when (not= 1 (count high-findings)) "s"))
             "/static/img/icons/review-alerttriangle.svg"
             "review-overview__gap-group--high"
             high-findings])
          (when (seq medium-findings)
            [review-overview-gap-group
             (str (count medium-findings) " Medium Severity Issue" (when (not= 1 (count medium-findings)) "s"))
             "/static/img/icons/review-alertcircle.svg"
             "review-overview__gap-group--medium"
             medium-findings])]])]]))

(defn- findings-help-content []
  [:<>
   [:p [:strong "Finding"] ": A potential issue with the governing documents or a deviation from best practices outlined in the iPaladin® LMP™."]
   [:p [:strong "Priority"] ": AARK™ suggests an initial priority. Adjust as needed before confirming.  What you confirm shapes future reviews."]
   [:p [:strong "Findings may be classified in three ways:"]]
   [:ol
    [:li [:strong "Action Item"] ": The finding requires remediation. It becomes a step in the remediation task."]
    [:li [:strong "Exception"] ": The finding applies to this collection, but a documented deviation has been acknowledged or approved (e.g., a trust exceeding a concentration limit with trustee sign-off)."]
    [:li [:strong "Not Applicable"] ": The finding does not apply to this specific collection (e.g., while generally true per the LMP™, for this collection it is not). Future reviews won't re-surface what you've already dismissed."]]])

(defn- review-tab-findings [*findings save-draft-fn]
  [:div.review-report__tab-content
   [:div.review-report__findings-header
    [:h3 "Detailed Findings"
     [:span.review-report__findings-count
      (str " (" (count @*findings) ")")]]
    [help-popover [findings-help-content] {:size :xs}]]
   (doall
    (for [i (range (count @*findings))]
      ^{:key i}
      [review-finding-card i *findings save-draft-fn]))])


(defn- exceptions-help-content []
  [:<>
   [:p [:strong "Finding"] ": A potential violation of terms of the governing documents or a deviation from best practices outlined in the iPaladin® LMP™."]
   [:p [:strong "Findings may be classified in three ways:"]]
   [:ol
    [:li [:strong "Action Item"] ": The finding requires remediation. It becomes a step in the remediation task."]
    [:li [:strong "Exception"] ": The finding applies to this collection, but a documented deviation has been acknowledged or approved (e.g., a trust exceeding a concentration limit with trustee sign-off). The exception is recorded and persists to future reviews."]
    [:li [:strong "Not Applicable"] ": The finding does not apply to this specific collection (e.g., while generally true per the LMP™, for this collection it is not true). The N/A designation persists to future reviews."]]
   [:p [:strong "Severity"] ": Severity is initially determined by AARK™ based on its own assessment of the nature of the gap, the entity type, and contextual factors. There is no predefined severity matrix; AARK™ evaluates each finding independently. You may change the severity of each finding and the severity you select will persist to future reviews."]])

(defn- review-tab-exceptions [*findings save-draft-fn]
  ;; The header count is the length of the list below it, not a second count of
  ;; the same dispositions (#2988).
  (let [types #{"exception" "not_applicable"}
        indices (vec (keep-indexed
                      (fn [i f] (when (contains? types (:resolution f)) i))
                      @*findings))]
    [:div.review-report__tab-content
     [:div.review-report__findings-header
      [:h3 "Exceptions"
       [:span.review-report__findings-count
        (str " (" (count indices) ")")]]
      [help-popover [exceptions-help-content] {:size :xs :offset 80}]]
     (if (seq indices)
       (doall
        (for [i indices]
          ^{:key i}
          [review-finding-card i *findings save-draft-fn]))
       [:p.review-report__empty "No exceptions recorded."])]))

;; --------------- Action Items tab (task creation) ---------------

(defn- user-display-name [user]
  (str (:first_name user) " " (:last_name user)))

(defn- action-item-assignee-select
  "Dropdown for selecting a user to assign a step to."
  [*users step-index *task-steps]
  (let [steps @*task-steps
        current-uid (get-in steps [step-index :assignee_user_id] 0)
        users @*users]
    [:select.action-items__assignee
     {:value (str current-uid)
      :on-change #(swap! *task-steps assoc-in [step-index :assignee_user_id]
                         (js/parseInt (-> % .-target .-value) 10))}
     [:option {:value "0"} "Default (me)"]
     (doall
      (for [u users]
        ^{:key (:id u)}
        [:option {:value (str (:id u))} (user-display-name u)]))]))

(defn- findings-by-id
  "Index findings by their server-assigned id (#2979)."
  [findings]
  (into {} (map (juxt :id identity)) findings))

(defn- action-item-finding-row
  "A single action-item finding row with checkbox + title + assignee dropdown.
  Selection and steps are keyed by the finding's server-assigned id."
  [finding finding-id *users step-index *task-steps *selected-for-group]
  (let [selected? (contains? @*selected-for-group finding-id)
        task-steps @*task-steps
        finding-ids (mapv :finding_id task-steps)
        sel-idxes  (->> finding-ids
                        (keep-indexed (fn [i fid]
                                        (when (contains? @*selected-for-group fid) i)))
                        sort)
        min-sel    (first sel-idxes)
        max-sel    (last sel-idxes)
        can-interact? (or (empty? sel-idxes)
                          (and selected?
                               (or (= step-index min-sel) (= step-index max-sel)))
                          (and (not selected?)
                               (or (< step-index min-sel)
                                   (> step-index max-sel))))
        expand-selection! (fn []
                            (let [range-idxes (cond
                                                (< step-index min-sel)
                                                (range step-index min-sel)
                                                (> step-index max-sel)
                                                (range (inc max-sel) (inc step-index))
                                                :else [step-index])]
                              (swap! *selected-for-group
                                     into (map #(nth finding-ids %) range-idxes))))]
    [:div.action-items__finding-row
     [:label.action-items__checkbox-label
      {:class (when-not can-interact? "is-disabled")}
      [:input {:type      "checkbox"
               :checked   selected?
               :disabled  (not can-interact?)
               :on-change (fn [_]
                            (when can-interact?
                              (if selected?
                                (swap! *selected-for-group disj finding-id)
                                (if (empty? sel-idxes)
                                  (swap! *selected-for-group conj finding-id)
                                  (expand-selection!)))))}]
      [:span.action-items__step-number (str (inc step-index) ".")]
      [:span.action-items__finding-title (:title finding)]
      [:span.action-items__finding-severity
       {:class (severity-class (:severity finding))}
       (str/capitalize (:severity finding))]]
     [action-item-assignee-select *users step-index *task-steps]]))

(defn- dep-group-block
  "Renders a created dependent-steps group with step rows and a delete button."
  [group-idx group-steps *task-steps *dep-groups *findings *users]
  (let [by-id (findings-by-id @*findings)]
    [:div.action-items__dep-group
     [:div.action-items__dep-group-header
      [:span.action-items__dep-group-title
       (str (count group-steps) " Non-dependent Step"
            (when (not= 1 (count group-steps)) "s"))]
      [:button.action-items__dep-group-delete
       {:on-click (fn [_]
                    (let [ids (set (map :finding_id group-steps))]
                      (swap! *task-steps
                             (fn [steps]
                               (mapv (fn [s]
                                       (if (contains? ids (:finding_id s))
                                         (assoc s :group_index -1)
                                         s))
                                     steps)))
                      (swap! *dep-groups dissoc group-idx)))}
       "✕"]]
     (doall
      (for [[i step] (map-indexed vector group-steps)
            :let [finding  (get by-id (:finding_id step))
                  step-idx (.indexOf (to-array (mapv :finding_id @*task-steps))
                                     (:finding_id step))]]
        ^{:key i}
        [:div.action-items__dep-step-row
         [:span.action-items__step-number (str (inc step-idx) ".")]
         [:span.action-items__dep-step-title (:title finding)]
         [action-item-assignee-select *users step-idx *task-steps]]))]))

(defn- review-tab-action-items
  "Unified Action Items tab — groups appear inline at their task-order position."
  [*findings *task-steps *dep-groups *users *selected-for-group]
  (let [steps    @*task-steps
        groups   @*dep-groups
        selected @*selected-for-group
        selected-count (count selected)
        by-id    (findings-by-id @*findings)
        finding-ids (mapv :finding_id steps)
        fid->group-idx (into {} (mapcat (fn [[gidx g]]
                                          (map (fn [s] [(:finding_id s) gidx]) g))
                                        groups))
        [render-items _]
        (reduce (fn [[items seen] step]
                  (let [fid   (:finding_id step)
                        gidx  (get fid->group-idx fid)
                        sidx  (.indexOf (to-array finding-ids) fid)]
                    (cond
                      (and gidx (contains? seen gidx)) [items seen]
                      gidx [(conj items {:type :group :group-idx gidx :key fid}) (conj seen gidx)]
                      :else [(conj items {:type :step :fid fid :step-idx sidx :key fid}) seen])))
                [[] #{}]
                steps)
        first-sel-key
        (when (pos? selected-count)
          (->> finding-ids
               (keep-indexed (fn [i fid] (when (contains? selected fid) i)))
               sort
               first
               (nth finding-ids)))
        on-group (fn []
                   (let [next-idx    (inc (reduce max 0 (keys groups)))
                         group-steps (filterv #(contains? selected (:finding_id %)) steps)]
                     (swap! *task-steps
                            (fn [all-steps]
                              (mapv (fn [s]
                                      (if (contains? selected (:finding_id s))
                                        (assoc s :group_index next-idx)
                                        s))
                                    all-steps)))
                     (swap! *dep-groups assoc next-idx
                            (mapv #(assoc % :group_index next-idx) group-steps))
                     (reset! *selected-for-group #{})))
        selection-bar
        [:div.action-items__selection-row
         {:key :selection-bar}
         [:div.action-items__selection-left
          [:span.action-items__selection-count
           (str selected-count " finding" (when (not= 1 selected-count) "s") " selected")]
          (when (pos? selected-count)
            [:button.action-items__clear-selection-btn
             {:on-click (fn [_] (reset! *selected-for-group #{}))}
             "✕ Clear"])]
         [:button.action-items__create-group-btn
          {:disabled (< selected-count 2)
           :on-click (fn [_] (on-group))}
          "Group as non-dependent"]]]
    [:div.review-report__tab-content.action-items
     [:div.action-items__heading
      [:h3 "Create task for findings"]
      [:p.action-items__description
       "Check consecutive steps to group them as non-dependent — they will appear together and can be worked on simultaneously. "
       "Everything else runs sequentially, each step unlocked after the previous one completes."]]
     [:div.action-items__unified-list
      (doall
       (mapcat (fn [{:keys [type group-idx fid step-idx key]}]
                 (let [item (case type
                               :group (with-meta
                                        [dep-group-block group-idx (get groups group-idx)
                                         *task-steps *dep-groups *findings *users]
                                        {:key key})
                               :step  (with-meta
                                        [action-item-finding-row (get by-id fid) fid *users
                                         step-idx *task-steps *selected-for-group]
                                        {:key key}))]
                   (if (and (pos? selected-count) (= key first-sel-key))
                     [selection-bar item]
                     [item])))
               render-items))]]))

(defn- review-sidebar-content [*findings *task-steps *dep-groups *users
                               *selected-for-group *enriched-args save-draft-fn on-discard *discarding]
  (let [*active-tab (atom :overview)]
    (fn [*findings *task-steps *dep-groups *users *selected-for-group *enriched-args save-draft-fn on-discard *discarding]
      (let [args @*enriched-args]
        [:div.review-report
         [review-header args on-discard @*discarding]
         [review-tab-bar *active-tab *findings]
         (case @*active-tab
           :overview     [review-tab-overview *findings args]
           :findings     [review-tab-findings *findings save-draft-fn]
           :exceptions   [review-tab-exceptions *findings save-draft-fn]
           :action-items [review-tab-action-items *findings *task-steps *dep-groups
                          *users *selected-for-group]
           nil)]))))

(defn finalize-collection-review [{:keys [*sidebar-panels
                                          *sidebar-open
                                          *disabled
                                          *selected-family-id
                                          register-confirm-action-fn
                                          tool-update-success-cb
                                          deny-confirmation!]
                                   :as options}
                                  system-message-obj
                                  {{:keys [review_id lmp_name lmp_version findings]
                                    :as args} :arguments
                                   actual-args :actual_arguments
                                   :as tool-call}]
  (let [;; Prefer actual-arguments (user edits saved via update-args) over the original
        ;; AARK-generated arguments. Falls back to AARK findings if no edits saved yet.
        effective-findings (or (not-empty (:findings actual-args)) findings)
        action-step (fn [f] {:finding_id (:id f)
                             :assignee_user_id 0
                             :group_index -1})]
  (with-let [*findings (atom (vec (or effective-findings [])))
             *task-steps (atom (vec (keep
                                    (fn [f]
                                      (when (= (:resolution f) "action_item")
                                        (action-step f)))
                                    (or effective-findings []))))
             *dep-groups (atom {})
             *users (atom nil)
             *selected-for-group (atom #{})
             _ (add-watch *findings ::sync-task-steps
                          (fn [_ _ _ new-findings]
                            (let [action-findings (filterv #(= (:resolution %) "action_item") new-findings)
                                  action-ids (set (map :id action-findings))
                                  existing-ids (set (map :finding_id @*task-steps))
                                  to-add (filterv #(not (contains? existing-ids (:id %))) action-findings)
                                  to-remove (filterv #(not (contains? action-ids %)) existing-ids)]
                              (when (or (seq to-add) (seq to-remove))
                                (swap! *task-steps
                                       (fn [steps]
                                         (-> (filterv #(contains? action-ids (:finding_id %)) steps)
                                             (into (mapv action-step to-add)))))
                                (swap! *dep-groups
                                       (fn [groups]
                                         (into {} (keep (fn [[k gs]]
                                                          (let [remaining (filterv #(contains? action-ids (:finding_id %)) gs)]
                                                            (when (seq remaining) [k remaining])))
                                                        groups))))
                                (swap! *selected-for-group
                                       (fn [sel]
                                         (into #{} (filter action-ids) sel)))))))
             *side-panel-close (atom nil)
             *enriched-args (atom args)
             *discarding (atom false)
             *discarded (atom false)
             ;; A discarded review leaves this save prompt with nothing to save. Declining
             ;; it as Cancel does keeps the chat going, and AARK learns why (#3085).
             release-discarded-draft! (fn []
                                        (reset! *discarded true)
                                        (when-let [close-fn @*side-panel-close]
                                          (close-fn))
                                        (reset! *sidebar-open false)
                                        (deny-confirmation!))
             ;; The finalize tool input carries no collection_id (#2979) — the
             ;; metadata endpoint (addressed by review id) returns it along with
             ;; the overview counts, and the collection fetches chain off it.
             fetch-collection-data
             (fn [collection-id]
               (->> (collection-model/permitted-users {:task-assign true} [collection-id])
                    (p/map (fn [response] (reset! *users response)))
                    (process-error))
               (->> (collection-model/collection-details collection-id)
                    (p/map (fn [col]
                             (let [type-str (when-let [ct (:collection_type col)]
                                              (coltype-model/collection-type-name ct))
                                   status-str (if (:active col) "Active" "Inactive")]
                               (swap! *enriched-args merge
                                      (cond-> {:collection_status status-str}
                                        type-str (assoc :collection_type type-str))))))
                    (process-error)))
             _ (when (pos? (or review_id 0))
                 (->> (api/ajaxp (str "/collection_review/" review_id "/metadata") {})
                      (p/map (fn [meta]
                               (swap! *enriched-args merge
                                      (cond-> {:generated_by_name (:initiated_by_name meta)
                                               :collection_name (:collection_name meta)
                                               :parent_collection_name (not-empty (:parent_collection_name meta))
                                               :document_count (:document_count meta)
                                               :subcollection_count (:subcollection_count meta)
                                               :pending_task_count (:pending_task_count meta)
                                               :pending_compliance_count (:pending_compliance_count meta)}
                                        (:last_reviewed_date meta) (assoc :last_reviewed_date (:last_reviewed_date meta))))
                               ;; The tool arguments may legitimately omit the compliant items —
                               ;; the server then keeps the latest version's, which is what
                               ;; metadata returns. Fill the gap rather than overwrite: items the
                               ;; model did send are what will be persisted. The counters need no
                               ;; such fill since #2988 — the panel derives them from the findings
                               ;; and these items, the same way the server does.
                               (swap! *enriched-args
                                      (fn [a]
                                        (cond-> a
                                          (empty? (:compliant_items a))
                                          (assoc :compliant_items (:compliant_items meta)))))
                               (when (pos? (or (:collection_id meta) 0))
                                 (fetch-collection-data (:collection_id meta)))))
                      ;; Discarded from the collection page while this prompt waited.
                      (p/error (fn [e]
                                 (if (= 404 (:status e))
                                   (release-discarded-draft!)
                                   (throw e))))
                      (process-error)))
             on-discard (fn []
                          (collection/confirm-discard-review
                           review_id *discarding
                           (fn [_] (release-discarded-draft!))))
             wrapped-success-cb (fn []
                                  (when-let [close-fn @*side-panel-close]
                                    (close-fn))
                                  (reset! *sidebar-open false)
                                  (tool-update-success-cb))
             ;; Called explicitly from review-finding-card at committed decision points
             ;; (confirm/cancel exemption, severity change, direct resolution toggle).
             ;; Updates the tool call args in the DB so findings survive a page refresh.
             ;; Uses the same :update-args mechanism as the final Confirm, but without
             ;; a success-cb so the panel stays open.
             save-draft-fn (fn []
                             (let [updated-args (assoc @*enriched-args :findings @*findings)]
                               (controller/dispatch
                                :chat-tool-call
                                :update-args
                                {:tool-call-id (:id tool-call)
                                 :args         updated-args})))
             _ (register-confirm-action-fn
                (fn []
                  (let [updated-findings @*findings
                        current-steps @*task-steps
                        has-steps (pos? (count current-steps))
                        updated-args (merge @*enriched-args
                                            {:findings updated-findings
                                             :create_task has-steps
                                             :task_steps current-steps})]
                    (controller/dispatch
                     :chat-tool-call
                     :update-args
                     {:tool-call-id (:id tool-call)
                      :args updated-args
                      :success-cb wrapped-success-cb}))))
             _ (let [[remove-fn _] (add-sidebar-panel
                                    *sidebar-panels
                                    {:hide-chrome true}
                                    :collection-review
                                    "Collection Review"
                                    [review-sidebar-content *findings *task-steps *dep-groups
                                     *users *selected-for-group *enriched-args save-draft-fn on-discard *discarding])]
                 (reset! *side-panel-close remove-fn)
                 (reset! *sidebar-open true))]
    [:div
     [:div.review-report--inline
      [:img {:src "/static/img/icons/review-report.svg"
             :style {:width "1em" :height "1em" :vertical-align "middle" :margin-right "0.3em"}}]
      [:strong "Collection Review"]
      (when lmp_name
        [:span " — " (util/entity lmp_name)])
      [:span.review-report--inline__hint (if @*discarded " (review discarded)" " (editing in sidebar)")]]
     ;; The chat cannot send while this draft awaits Confirm or Cancel; the hint sits by Cancel (#3085).
     (when-not @*discarded
       [:p.c-review-draft-hint
        "Cancel to ask AARK™ a question or have it fix findings first — AARK™ can then re-run the review. "
        "Edits made in the side panel and not yet confirmed are lost on Cancel."])])))

(defn start-collection-review [_options
                                _system-message-obj
                                {{:keys [collection_name]} :meta
                                 :as _tool-call}]
  [:div.o-media--margin
   [:p [:strong "Collection Review"] " — " collection_name]])

(defn- findings-version-card [label findings]
  (let [n (count findings)]
    [:div.o-media--margin
     [:p [:strong "Collection Review"] " — " label " ("
      n " finding" (when (not= 1 n) "s") ")"]]))

(defn record-review-findings [_options
                              _system-message-obj
                              {{:keys [findings]} :arguments
                               :as _tool-call}]
  [findings-version-card "findings recorded" findings])

(defn revise-review-findings [_options
                              _system-message-obj
                              {{:keys [findings]} :arguments
                               :as _tool-call}]
  [findings-version-card "findings revised" findings])

